<template>
  <div class="olvapicy">
    <div class="userment-background">
      <div class="userment-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        隐私政策
      </div>
      <p class="userment-Headline">欧堡利亚隐私权政策</p>
      <p class="userment-content">欧堡利亚APP尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，欧堡利亚APP会按照本隐私权政策的规定使用和披露您的个人信息。但欧堡利亚APP将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，欧堡利亚APP不会将这些信息对外披露或向第三方提供。欧堡利亚APP会不时更新本隐私权政策。您在同意欧堡利亚APP服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于欧堡利亚APP服务使用协议不可分割的一部分。</p>
      <p class="userment-content">1.适用范围</p>
      <p class="userment-content">a)在您使用欧堡利亚APP网络服务，或访问欧堡利亚APP平台网页时，欧堡利亚APP自动接收并记录的您的浏览器和计算机_上的信息，包括但不限于您的IP 地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。</p>
      <p class="userment-content">b)欧堡利亚APP通过合法途径从商业伙伴处取得的用户个人数据。</p>
      <p class="userment-content">2.信息使用</p>
      <p class="userment-content">a)欧堡利亚APP不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和欧堡利亚APP (含欧堡利亚APP关联公司)单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>
      <p class="userment-content">b)欧堡利亚APP亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何欧堡利亚APP平台用户如从事上述活动，一经发现，我司有权立即终止与该用户的服务协议。</p>
      <p class="userment-content">c）欧堡利亚APP会使用用户摄像头功能以便用户进行头像的更换和扫描二维码，公司承诺使用者不会有被远程监控的情况。</p>
      <p class="userment-content">3.信息披露</p>
      <p class="userment-content">在如下情况下，欧堡利亚APP将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
      <p class="userment-content">a)经您事先同意，向第三方披露；</p>
      <p class="userment-content">b)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
      <p class="userment-content">c)其它欧堡利亚APP根据法律、法规或者网站政策认为合适的披露。</p>
      <p class="userment-content">4.信息存储和交换</p>
      <p class="userment-content">欧堡利亚APP收集的有关您的信息和资料将保存在欧堡利亚APP及(或)其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或欧堡利亚APP收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
      <p class="userment-content">5.信息安全</p>
      <p class="userment-content">a)欧堡利亚APP帐号均有安全保护功能，请妥善保管您的用户名及密码信息。欧堡利亚APP将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施。</p>
      <p class="userment-content">b)在使用欧堡利亚APP网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是欧堡利亚APP用户名及密码发生泄露，请您立即联络欧堡利亚APP客服，以便欧堡利亚APP采取相应措施。</p>
      <p class="userment-Sigture">江苏欧堡利亚实业有限公司</p>
    </div>
    <TextTips></TextTips>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      
    }
  },
  created(){
    
  },
  mounted(){
     
  },
  methods:{
    // 点击返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/userment.css";
</style>